export default {
    user: null,
    auth: null,
    menu: [
        {
            label: 'Já sou filiado',
            route: 'autenticacao',
            url: null,
            params: {},
            viewFooter: false,
            viewHeader: true,
        },
        {
            label: 'Contato',
            route: 'contato',
            url: null,
            params: {},
            viewFooter: true,
            viewHeader: false,
        },
        {
            label: 'Filie-se',
            route: 'filiacao',
            url: null,
            params: {},
            viewFooter: false,
            viewHeader: true,
        },
        {
            label: 'Contribua',
            route: null,
            url: process.env.VUE_APP_ENDPOINT_URL + 'contribuicao',
            params: {},
            viewFooter: false,
            viewHeader: true,
        },
        {
          label: 'Parlamentares e Governantes',
          route: null,
          url: process.env.VUE_APP_ENDPOINT_URL + 'cargos-partidarios',
          params: {},
          viewFooter: false,
          viewHeader: true,
        },
        {
          label: 'Direções e Diretórios',
          route: null,
          url: process.env.VUE_APP_ENDPOINT_URL + 'cargos-partidarios/direcoes-e-diretorios',
          params: {},
          viewFooter: false,
          viewHeader: true,
        },
    ],
}



// WEBPACK FOOTER //
// ./src/vuex/state.js